export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_10.bf4bf88e.mp4";